import ff from './ff';

export default class i1zd { // 予約情報

static d_defs = {

/*
  DROP TABLE t_i1zr;
  CREATE TABLE t_i1zr (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    i1zrb31f INTEGER,
    i1zrb21f INTEGER,
    i1zrb41f INTEGER,
    i1zrc11s TEXT,
    i1zrt11i INTEGER,
    i1zrt21i INTEGER,
    i1zrt31i INTEGER,
    i1zrs11i INTEGER,
    i1zrs21i INTEGER,
    i1zrs22i INTEGER,
    i1zri11d TEXT,
    i1zri21d TEXT,
    i1zri11s TEXT,
    i1zri12s TEXT,
    i1zri21s TEXT,
    i1zri22s TEXT,
    i1zri31s TEXT,
    i1zri32s TEXT,
    i1zrt41i INTEGER,
    i1zri41s TEXT,
    i1zri41i INTEGER,
    i1zri11m BIGINT,
    i1zri51s TEXT,
    i1zrcx1i INTEGER,
    i1zrcy1t TEXT,
    i1zrcy1f INTEGER,
    i1zrcz1i INTEGER
  );
  UPDATE t_i1zr SET _fst = _key;
*/

  i1zr: { // 抽選があるため、利用日ごとに予約を登録せざるをえない
    0: {
      pfx: '予約基本情報',
      b_vsn: true,
      d_insFlds: {
        i1zrb31f: -1,
        i1zrb21f: -1,
        i1zrc11s: '-',
        i1zrt11i: -1,
        i1zrs11i: 0,
        i1zrs21i: 0,
        i1zri11d: ff.myDT_getDate('today'),
//        i1zri21d: ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), 2),
        i1zri21d: '',
        i1zri11s: '',
        i1zri12s: '',
        i1zri21s: '',
        i1zri31s: '',
        i1zrt21i: 0,
        i1zrs11i: 0,
        i1zri11m: 0,
        i1zrt41i: 0,
        i1zri41s: '',
        i1zri41i: 0,
      },
      dd_fldDefss: {
        i1zrb21f: { // c20m_key
          pfx: '利用会社',
          type: 'Inp',
        },
        i1zrb31f: { // c10m_key
          pfx: '団体',
          type: 'PckSch',
          n_col: 15,
//          b_tail: true,
        },
        i1zrb41f: { // i10r_fst
          pfx: '室・設備',
          type: 'Pck',
//          type: 'Inp',
          n_col: 10,
        },
        i1zrc11s: {
          pfx: 'ID',
          type: 'Inp',
          n_col: 5,
          o_stlVal: _d_dats => ff.myCM_pdd(_d_dats.d_flds.i1zrc11s, 5),
          lo_qrys: [
            _d_vals => {
              let _qry = `
                UPDATE
                  t_i1zr
                SET
                  i1zrc11s = _fst
                WHERE
                  t_i1zr.i1zrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND t_i1zr._vsn = t_i1zr._ltt
                  AND t_i1zr._fst = {}
              `.f(
                _d_vals.i1zr_fst
              ); // 毎回処理するのか？
              return _qry
            },
          ],

        },

        i1zrt11i: {
          pfx: '優先',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '対象' },
            { key:  0, pfx: '対象外' },
          ],
        },

        i1zrt21i: {
          pfx: '利用料の請求',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'あり' },
            { key:  0, pfx: 'なし' },
          ],
        },

        i1zrt31i: {
          pfx: '更新の確認',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'あり' },
            { key:  0, pfx: 'なし' },
          ],
        },

        i1zrs11i: { // 直接予約
          pfx: '状況',
          type: 'Pck',
          n_col: 9,
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: '予約なし' },
            { key:  20, pfx: 'キャンセル済' },
            { key:  60, pfx: '落選' },
            { key:  70, pfx: '仮押' },
            { key:  80, pfx: '仮予約' },
            { key:  90, pfx: '本予約' },
          ],
        },

        i1zrs21i: { // エントリー
          pfx: '状況',
          type: 'Pck',
          n_col: 9,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key:  0, pfx: 'エントリーなし' },
            { key: 20, pfx: 'キャンセル済' },
            { key: 40, pfx: 'エントリー中' },
            { key: 60, pfx: '落選' },
            { key: 80, pfx: '当選' },
          ],
        },

        i1zrs22i: { // 優先エントリー
          pfx: '状況',
          type: 'Pck',
          n_col: 9,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key:  0, pfx: 'エントリーなし' },
            { key: 20, pfx: 'キャンセル済' },
            { key: 40, pfx: 'エントリー中' },
            { key: 60, pfx: '落選' },
            { key: 80, pfx: '当選' },
          ],
        },

        i1zrs31i: {
          pfx: '当選メール送信状況',
          type: 'Pck',
          n_col: 15,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key:  0, pfx: '未送信' },
            { key: 10, pfx: '送信済' },
          ],
        },

        i1zri11d: {
          pfx: '申込日',
          type: 'PckDate',
        },

        i1zri21d: {
          pfx: '利用日',
          type: 'PckDate',
        },

        i1zri11s: {
          pfx: '申込者',
          type: 'Inp',
        },

        i1zri12s: {
//          pfx: '連絡先',
          pfx: '電話番号',
          type: 'Inp',
        },
/*
        i1zri21s: {
          pfx: '目的',
          type: 'Inp',
          n_col: 15,
        },

        i1zri22s: {
          pfx: '備考',
          type: 'Inp',
          n_col: 15,
        },
*/
        i1zri31s: {
          pfx: '代表者',
          type: 'Inp',
          n_col: 15,
        },
        i1zri32s: {
          pfx: '利用制限',
//          type: 'Inp',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: 'なし' },
            { key:  10, pfx: 'WEB予約・エントリーを制限' },
          ],
          n_col: 15,
        },
        i1zrt41i: {
          pfx: '貸出備品',
          type: 'Pck',
          n_col: 5,
          ini: 10,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key:  0, pfx: 'なし' },
            { key: 10, pfx: 'あり' },
          ],
        },
        i1zri41s: { // 追加
//          pfx: '内容',
          pfx: '利用目的',
          type: 'Inp',
          n_col: 10,
        },
        i1zri41i: { // 追加
          pfx: '人数',
          type: 'Inp',
          n_col: 5,
          bsd: '人',
        },
        i1zri11m: { // 追加
          pfx: '利用料計',
          type: 'Inp',
          n_col: 5,
        },
        i1zri51s: {
          pfx: 'メモ',
          type: 'Inp',
          n_col: 62,
        },
        i1zri61s: {
          pfx: '団体名',
          type: 'Inp',
          n_col: 62,
          lo_qrys: [
            _d_vals => {
              let _qry = `
                UPDATE
                  t_i1zr
                SET
                  i1zri61s = (
                    SELECT 
                      B.c30rc31s 
                    FROM 
                      t_c30r AS B
                    WHERE 
                      B._vsn = B._ltt
                      AND B._fst = (
                        SELECT
                          A.i1zrb31f
                        FROM
                          t_i1zr AS A
                        WHERE
                          A.i1zrb21f = t_i1zr.i1zrb21f
                          AND A._vsn = A._ltt
                          AND A._fst = t_i1zr._fst
                      )
                  )
                WHERE
                  t_i1zr.i1zrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND t_i1zr._vsn = t_i1zr._ltt
                  AND t_i1zr._fst = {}
              `.f(
                _d_vals.i1zr_fst
              );
              return _qry
            },
          ],
        },
        i1zri62s: {
          pfx: '利用時間帯',
          type: 'Inp',
          n_col: 10,
          lo_qrys: [
            _d_vals => {
              let _qry = `
                UPDATE
                  t_i1zr
                SET
                  i1zri62s = ARRAY_TO_STRING(
                    ARRAY(
                      SELECT 
                        C.i110c31s 
                      FROM 
                        t_i110 AS C
                      WHERE 
                        C._vsn = C._ltt
                        AND C._fst IN (
                          SELECT
                            B.i1z0b51f
                          FROM
                            t_i1z0 AS B
                          WHERE
                            B.i1z0b61k = (
                              SELECT
                                A._key
                              FROM
                                t_i1zr AS A
                              WHERE
                                A.i1zrb21f = t_i1zr.i1zrb21f
                                AND A._vsn = A._ltt
                                AND A._fst = t_i1zr._fst
                            )
                        )
                      ORDER BY
                        C.i110c11s::NUMERIC::INTEGER
                    ), 
                    '・'
                  )
                WHERE
                  t_i1zr.i1zrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND t_i1zr._vsn = t_i1zr._ltt
                  AND t_i1zr._fst = {}
              `.f(
                _d_vals.i1zr_fst
              );
              return _qry
            },
          ],
        },
      },
    },
  },

/*
  DROP TABLE t_i1z0;
  CREATE TABLE "t_i1z0" ("_key" SERIAL PRIMARY KEY, "_vsn" INTEGER, "_ltt" INTEGER, "_fst" INTEGER, 
    "i1z0b31f" INTEGER,
    "i1z0b21f" INTEGER,
    "i1z0b41f" INTEGER,
    "i1z0b51f" INTEGER,
    "i1z0b61k" INTEGER,
    "i1z0i21d" TEXT,
    "i1z0s11i" INTEGER,
    "i1z0s21i" INTEGER,
    "i1z0i11m" BIGINT,
    "i1z0i12m" BIGINT,
    "i1z0i11i" INTEGER,
    "i1z0t11i" INTEGER,
    "i1z0i21s" TEXT,
    "i1z0i31i" INTEGER,
    "i1z0cx1i" INTEGER,
    "i1z0cy1t" TEXT,
    "i1z0cy1f" INTEGER,
    "i1z0cz1i" INTEGER
  );
  UPDATE t_i1z0 SET _fst = _key;
*/

  i1z0: {
    0: {
      pfx: '利用室情報',
      b_vsn: true,
      d_insFlds: {
        i1z0b41f: -1,
        i1z0b51f: -1,
        i1z0i11d: '',
        i1z0i11m:  0,
        i1z0i12m:  0,
        i1z0s11i:  0,
        i1z0i11i:  0,
        i1z0t11i: 10,
        i1z0i21s: '',
        i1z0i31i:  0,
      },
      dd_fldDefss: {
        i1z0b21f: { // c20r_fst
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        i1z0b31f: { // c10r_key
          pfx: 'c30r_key',
          type: 'Inp',
        },
        i1z0b41f: { // i10r_fst
          pfx: '室・設備',
          type: 'Pck',
          n_col: 10,
        },
        i1z0b51f: { // i110_fst
          pfx: '時間帯',
          type: 'Pck',
          n_col: 5,
        },
        i1z0b61k: { // i1zr_key
          pfx: '予約情報',
          type: 'Inp',
        },
        i1z0i21d: {
          pfx: '利用日',
          type: 'PckDate',
          n_col: 8,
        },
        i1z0s11i: { // エントリー状況 i1z0s21i は不要
          pfx: '予約状況',
          type: 'Pck',
          n_col: 8,
        },
        i1z0i11m: { // 不使用？
          pfx: '利用料',
          type: 'Inp',
          n_col: 4,
        },
        i1z0i12m: { // 不使用？
          pfx: '単価',
          type: 'Inp',
          n_col: 4,
        },
        i1z0i11i: {
          pfx: '数量',
          type: 'Inp',
          n_col: 3,
        },
        i1z0t11i: {
          pfx: '貸出備品',
          type: 'Pck',
          n_col: 5,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key:  0, pfx: 'あり' },
            { key: 10, pfx: 'なし' },
          ],
        },
        i1z0i21s: { // 追加
          pfx: '内容',
          type: 'Inp',
          n_col: 10,
        },
        i1z0i31i: { // 追加
          pfx: '人数',
          type: 'Inp',
          n_col: 5,
        },
      },
    },
  },

/*
  DROP TABLE t_i1z1;
  CREATE TABLE "t_i1z1" ("_key" SERIAL PRIMARY KEY, "_vsn" INTEGER, "_ltt" INTEGER, "_fst" INTEGER, 
    "i1z1b21f" INTEGER,
    "i1z1b61k" INTEGER,
    "i1z1i11m" BIGINT,
    "i1z1t21i" INTEGER,
    "i1z1i21i" INTEGER,
    "i1z1t22i" INTEGER,
    "i1z1i21m" BIGINT,
    "i1z1i31m" BIGINT,
    "i1z1i31d" TEXT,
    "i1z1i41d" TEXT,
    "i1z1s11i" INTEGER,
    "i1z1cx1i" INTEGER,
    "i1z1cy1t" TEXT,
    "i1z1cy1f" INTEGER,
    "i1z1cz1i" INTEGER
  );
  UPDATE t_i1z1 SET _fst = _key;
*/

  i1z1: {
    0: {
      pfx: '支払情報',
      b_vsn: true,
      d_insDats: {
        b_upd: false,
        b_new: true,
        b_dlt: false,
        d_flds: {
          i1zrb21f: -1,
          i1zrb41f: -1,
          i1zrb51f: -1,
          i1zri11d: ff.myDT_getNow(),
          i1zrt11i: -1,
          i10mcx1i: 9999,
          i10mcz1i: 10,
          i1z1s11i: 0,
        },
      },
      dd_fldDefss: {

        i1z1b21f: { // c20r_fst
          pfx: '利用会社',
          type: 'Inp',
        },

        i1z1b61k: { // i1zr_key
          pfx: '予約情報',
          type: 'Inp',
        },

        i1z1i11m: {
          pfx: '利用料計',
          type: 'Inp',
          n_col: 5,
        },

        i1z1t21i: {
          pfx: '減免率区分',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: 'なし' },
            { key:  50, pfx: '50%' },
            { key: 100, pfx: '100%' },
            { key: 999, pfx: '任意' },
          ],
          n_col: 5,
        },

        i1z1i21i: {
          pfx: '減免率',
          type: 'Inp',
          n_col: 5,
          bsd: '%',
        },

        i1z1t22i: {
          pfx: '減免理由',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'A' },
            { key: 20, pfx: 'B' },
            { key: 30, pfx: 'C' },
            { key: 40, pfx: 'D' },
          ],
        },

        i1z1i21m: {
          pfx: '減免額計',
          type: 'Inp',
          n_col: 5,
        },

        i1z1i31m: {
          pfx: '支払額計',
          type: 'Inp',
          n_col: 5,
        },

        i1z1i31d: {
          pfx: '支払期限',
          type: 'PckDate',
        },

        i1z1i41d: {
          pfx: '支払日',
          type: 'PckDate',
        },

        i1z1s11i: {
          pfx: '支払状況',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: '未払' },
            { key:  10, pfx: '支払済' },
          ],
        },

        i1z1t51i: {
          pfx: '支払方法',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:  10, pfx: '窓口' },
            { key:  20, pfx: '事前' },
          ],
        },

      },
    },
  },

/*
  DROP TABLE t_i1z2;
  CREATE TABLE "t_i1z2" ("_key" SERIAL PRIMARY KEY, "_vsn" INTEGER, "_ltt" INTEGER, "_fst" INTEGER, 
    "i1z2b21f" INTEGER,
    "i1z2b41f" INTEGER,
    "i1z2b61k" INTEGER,
    "i1z2i12m" BIGINT,
    "i1z2cx1i" INTEGER,
    "i1z2cy1t" TEXT,
    "i1z2cy1f" INTEGER,
    "i1z2cz1i" INTEGER
  );
*/

  i1z2: {
    0: {
      pfx: '利用設備情報',
      b_vsn: true,
      d_insFlds: {
        i1z2b41f: -1,
        i1z2b61f: -1,
        i1z2i12m:  0,
      },
      dd_fldDefss: {
        i1z2b21f: { // c20r_fst
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        i1z2b41f: { // i10r_fst
          pfx: '室・設備',
          type: 'Pck',
          n_col: 10,
        },
        i1z2b61k: { // i1zr_key
          pfx: '予約情報',
          type: 'Inp',
        },
        i1z2i12m: {
          pfx: '単価',
          type: 'Inp',
          n_col: 4,
        },
      },
    },
  },

/*
  DROP TABLE t_i1z3;
  CREATE TABLE t_i1z3 (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    i1z3b21f INTEGER,
    i1z3b41f INTEGER,
    i1z3b51f INTEGER,
    i1z3i21d TEXT,
    i1z3i31i INTEGER,
    i1z3cx1i INTEGER,
    i1z3cy1t TEXT,
    i1z3cy1f INTEGER,
    i1z3cz1i INTEGER
    , CONSTRAINT i1z3_unq1 UNIQUE (i1z3b21f, i1z3b41f, i1z3b51f, i1z3i21d)
  );

INSERT INTO
  t_i1z3
(
  i1z3b21f,
  i1z3b41f,
  i1z3b51f,
  i1z3i21d,
) VALUES (
  ${global.t?.state.sgcd_cmnStgs.c20r_fst},
  ${_d_vals.i1z3b41f},
  ${_d_vals.i1z3b51f},
  "${_d_vals.i1z3i21d}"
);

INSERT INTO
  t_i1z3
(
  i1z3b21f,
  i1z3b41f,
  i1z3b51f,
  i1z3i21d
) SELECT 
  DISTINCT
  i1zrb21f,
  i1zrb41f,
  i1z0b51f,
  i1zri21d
FROM
  t_i1z0 LEFT JOIN t_i1zr ON t_i1z0.i1z0b61k = t_i1zr._key
WHERE
  t_i1z0._vsn = t_i1z0._ltt
  AND t_i1zr._vsn = t_i1zr._ltt
GROUP BY
  i1zrb21f,
  i1zrb41f,
  i1z0b51f,
  i1zri21d
;

UPDATE
  t_i1z3
SET
  i1z3i31i = (
    SELECT
      COUNT(*)
    FROM
      t_i1z0 LEFT JOIN t_i1zr ON t_i1z0.i1z0b61k = t_i1zr._key
    WHERE
      i1z0b21f = i1z3b21f
      AND i1z0b41f = i1z3b41f
      AND i1z0b51f = i1z3b51f
      AND i1z0i21d = i1z3i21d
      AND COALESCE(i1z0cz1i, 10) = 10
      AND t_i1z0._vsn = t_i1z0._ltt
      AND i1zrs11i IN (70, 80, 90)
      AND COALESCE(i1zrcz1i, 10) = 10
      AND t_i1zr._vsn = t_i1zr._ltt
  )
;

*/


  i1z3: {
    0: {
      pfx: '予約状況カレンダー',
      b_vsn: false,
      dd_fldDefss: {
        i1z3b21f: { // c20r_fst
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        i1z3b41f: { // i10r_fst
          pfx: '室・設備',
          type: 'Pck',
          n_col: 10,
        },
        i1z3b51f: {
          pfx: '時間帯',
          type: 'Inp',
          n_col: 4,
        },
        i1z3i21d: { // i1zr_key
          pfx: '利用日',
          type: 'Inp',
        },
        i1z3i31i: {
          pfx: '直接予約数',
          type: 'Inp',
          n_col: 4,
          lo_qrys: [
            _d_vals => {
              let _qry = `
                INSERT INTO
                  t_i1z3
                (
                  i1z3b21f,
                  i1z3b41f,
                  i1z3b51f,
                  i1z3i21d
                ) SELECT 
                  DISTINCT
                  i1zrb21f,
                  i1zrb41f,
                  i1z0b51f,
                  i1zri21d
                FROM
                  t_i1z0 LEFT JOIN t_i1zr ON t_i1z0.i1z0b61k = t_i1zr._key
                WHERE
                  t_i1z0._vsn = t_i1z0._ltt
                  AND t_i1zr._vsn = t_i1zr._ltt
                  AND i1zri21d LIKE "{}"
                GROUP BY
                  i1zrb21f,
                  i1zrb41f,
                  i1z0b51f,
                  i1zri21d
                ON CONFLICT ON CONSTRAINT i1z3_unq1
                DO NOTHING
              `.f(                
                _d_vals.i1z3i21d
              );
//ff.l('i1zd 787: {}'.f(_qry));
              return _qry
            },
            _d_vals => {
              let _qry = `
                UPDATE
                  t_i1z3
                SET
                  i1z3i31i = (
                    SELECT
                      COUNT(*)
                    FROM
                      t_i1z0 LEFT JOIN t_i1zr ON t_i1z0.i1z0b61k = t_i1zr._key
                    WHERE
                      i1z0b21f = i1z3b21f
                      AND i1z0b41f = i1z3b41f
                      AND i1z0b51f = i1z3b51f
                      AND i1z0i21d = i1z3i21d
                      AND COALESCE(i1z0cz1i, 10) = 10
                      AND t_i1z0._vsn = t_i1z0._ltt
                      AND i1zrs11i IN (70, 80, 90)
                      AND COALESCE(i1zrcz1i, 10) = 10
                      AND t_i1zr._vsn = t_i1zr._ltt
                  )
                WHERE
                  i1z3i21d LIKE "{}%"
              `.f(
                String(_d_vals.i1z3i21d).substr(0,7)
              );
//ff.l('i1zd 813: {}'.f(_qry));
              return _qry
            },
          ],
        },
      },
    },
  },

};

};
